import React, { useEffect, useState, useRef } from "react";
import styled, { keyframes } from "styled-components";
import { Loader } from "semantic-ui-react";
import Typewriter from "typewriter-effect";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { SG_GET_CHAT_GPT_SUMMARY, CLEAR_CHAT_GPT_SUMMARY } from "constants/actions";
import Logo from "assets/images/Ilogo.svg";
import {words} from '../translations'
import SkipModal from "../Components/SkipModal";

const follow_ups = [
  {
    question: "This is the first question that was asked",
    response: "This was the response to the question",
  },
];


const outcome =
  "What follow-up question would a world-class culture consultant ask based on the feedback given that would help to get more context around this area and also help generate recommendations for this organization?";

const context =
  "This is a conversation between a person and an organization trying to dig deeper into the feedback given in an engagement survey.";

const contextFr =
  "Ceci est une conversation entre une personne et une organisation qui essaie d'approfondir les commentaires donnés dans une enquête sur l'engagement des employés.";

const contextPor =
  "Esta é uma conversa entre uma pessoa e uma organização que tenta profundar nos comentários dados em uma pesquisa de cultura.";

const outcomeFr = `Quelle question de suivi un consultant en culture de classe mondiale poserait-il en fonction des commentaires donnés qui aideraient à obtenir plus de contexte dans ce domaine et aideraient également à générer des recommandations pour cette organisation?`;

const contextEs =
  "Esta es una conversación entre una persona y una organización que intenta profundizar en los comentarios dados en una encuesta cultural.";

const outcomeEs = `¿Qué pregunta de seguimiento haría un consultor de cultura de clase mundial basada en los comentarios dados que ayudarían a obtener más contexto en esta área y también ayudarían a generar recomendaciones para esta organización?`;

const outcomePor = `Quais perguntas de acompanhamento um consultor de cultura de classe mundial faria com base nos comentários fornecidos que ajudariam a obter mais contexto sobre este assunto, e também ajudar a gerar recomendações para esta organização?`;

const MultiFollowUp = ({
  localToken,
  questionSequenceMap,
  currentQuestionDet,
  saveUpdatedAnswers,
  direction,
  handleNext,
  handleBack,
  language
}) => {
  const debug = () => {};
  const dispatch = useDispatch();
  const timeout = useRef(null);
  const [prompt, setPrompt] = useState(false);
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState("");
  const textareaRef = useRef();
  const [feedbackText, setFeedbackText] = useState("");
  const [refQues, setRefQues] = useState("");
  // skip modal
  const [open, setOpen] = useState(false);
  const lastEditAtRef = useRef(0);

  // Prevent duplicate POSTs: track the last requested signature dispatched to GPT
  const lastRequestedSignatureRef = useRef(null);

  // Build a stable signature from the referenced inputs to decide whether to (re)generate a GPT question
  const computeSignature = () => {
    try {
      const parts = Array.isArray(currentQuestionDet?.followUpQuestions)
        ? currentQuestionDet.followUpQuestions.map((cq) => {
            const prevResp = questionSequenceMap[cq]?.response?.response;
            const val =
              typeof prevResp === 'string'
                ? prevResp.trim()
                : prevResp === undefined || prevResp === null
                ? ''
                : JSON.stringify(prevResp);
            return `${cq}:${val}`;
          })
        : [];
      // Also include the referenced single/select input (askOnRefQID) so changes there force regeneration
      const askRefId = currentQuestionDet?.askOnRefQID;
      if (askRefId !== undefined && askRefId !== null) {
        const askRefResp = questionSequenceMap[askRefId]?.response?.response;
        const askRefVal =
          typeof askRefResp === 'string'
            ? askRefResp.trim()
            : askRefResp === undefined || askRefResp === null
            ? ''
            : JSON.stringify(askRefResp);
        parts.push(`ref:${askRefId}:${askRefVal}`);
      }
      // Include language since it affects generated question text
      return `${language}|${parts.join('|')}`;
    } catch {
      return `${language}|`;
    }
  };

  // console.log("MultiFollowUp", currentQuestionDet)
  // console.log("feedbackText", feedbackText)
  useEffect(() => {
    const timer1 = setTimeout(() => {
    
    }, 500);
    return () => clearTimeout(timer1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log("currentQuestionDet?.response?.question", currentQuestionDet)
  // console.log("!currentQuestionDet?.response?.question", !currentQuestionDet?.response?.question) 
  // console.log("!currentQuestionDet?.response?.questio currentQuestionDet?.followUpQuestions?.length >", !currentQuestionDet?.response?.question &&
  // currentQuestionDet?.followUpQuestions?.length > 0) 

  useEffect(() => {
    
    let followUpStrings = [];
    // if previous qestions were skipped ignore and skip this
    // we need to add this because of reset changes !currentQuestionDet?.response
    let SkipQuestion = [];


    const signature = computeSignature();
    const hasStoredQuestion = !!currentQuestionDet?.response?.question;
    const storedSignature = currentQuestionDet?.response?.prompt_signature;
    const sameSignature = typeof storedSignature === 'string' && storedSignature.length > 0 && storedSignature === signature;
    const hasRefs = Array.isArray(currentQuestionDet?.followUpQuestions) && currentQuestionDet?.followUpQuestions?.length > 0;
    const storedRespStr = typeof currentQuestionDet?.response?.response === 'string' ? currentQuestionDet?.response?.response : null;
    const shouldGenerateDueToEmpty = hasStoredQuestion && hasRefs && (storedRespStr === '' || storedRespStr === null);
    const shouldGenerate = (!hasStoredQuestion || !sameSignature || shouldGenerateDueToEmpty) && hasRefs;
    // Hydrate only when the stored question's signature matches AND we have a non-empty stored response
    // If stored response is empty, treat as regeneration to show loader and fetch a fresh question
    if (hasStoredQuestion && sameSignature && !(storedRespStr === '' || storedRespStr === null)) {
      let _q = currentQuestionDet?.response?.question;
      if (language === 'FR' && currentQuestionDet?.response?.fr) {
        _q = currentQuestionDet?.response?.fr;
      }
      if (language === 'ES' && currentQuestionDet?.response?.es) {
        _q = currentQuestionDet?.response?.es;
      }
      if (language === 'POR' && currentQuestionDet?.response?.por) {
        _q = currentQuestionDet?.response?.por;
      }
      setQuestion(_q || '');
      // Hydrate response only for same signature; otherwise, defer to regeneration path
      const typingWindowMs = 400;
      const now = Date.now();
      const recentlyTyping = now - (lastEditAtRef.current || 0) < typingWindowMs;
      if (!recentlyTyping) {
        if (sameSignature) {
          setFeedbackText(typeof currentQuestionDet?.response?.response === 'string' ? currentQuestionDet?.response?.response : '');
      
        } else {
          setFeedbackText('');
          
        }
      }
      console.log("fires here right now 1")
      setLoading(false);
    } else {
      // Regenerating: if there is no stored response, hide any existing question while loading
      if (!hasStoredQuestion || (storedRespStr === '' || storedRespStr === null)) {
        setQuestion('');
      }
      // Preserve user's in-progress typing if any
      const now = Date.now();
      const typingWindowMs = 1600;
      const recentlyTyping = now - (lastEditAtRef.current || 0) < typingWindowMs;
      if (!recentlyTyping && (!hasStoredQuestion || (storedRespStr === '' || storedRespStr === null))) {
        setFeedbackText('');
      }
      setLoading(true);
    }

    // Backfill only when signature is truly missing (undefined/null); if it's an empty string, it's a forced regeneration marker
    if (hasStoredQuestion && (currentQuestionDet?.response?.prompt_signature === undefined || currentQuestionDet?.response?.prompt_signature === null)) {
      const existingRespVal = typeof currentQuestionDet?.response?.response === 'string' ? currentQuestionDet?.response?.response : '';
      const ResponseObj = {
        ques_sort_order: currentQuestionDet.id,
        ques_order: currentQuestionDet?.id,
        id: currentQuestionDet.id,
        followUpQuestions: currentQuestionDet?.followUpQuestions,
        question_type: currentQuestionDet?.quesType,
        question: currentQuestionDet?.response?.question,
        // Store the prompt text (if known) and the computed signature separately
        prompt_question: (currentQuestionDet?.response?.prompt || prompt || ''),
        prompt_signature: signature,
        response: existingRespVal,
        clicked: currentQuestionDet?.response?.clicked || false,
      };
      
      saveUpdatedAnswers(
        currentQuestionDet?.id,
        ResponseObj,
        currentQuestionDet.quesType
      );
      return;
    }

    try {
      const referenced = (currentQuestionDet?.followUpQuestions || []).map((cq) => ({
        cq,
        value: questionSequenceMap[cq]?.response?.response,
        skip: questionSequenceMap[cq]?.response?.skip,
      }));
      
    } catch {}

    if (shouldGenerate) {
      // console.log("I am here ======================================= 67", currentQuestionDet?.id )
      setRefQues(questionSequenceMap[currentQuestionDet.followUpQuestions[0]]);

      // Build a request key that allows regeneration for empty-response cases even when signature is the same
      const requestKey = shouldGenerateDueToEmpty ? `${signature}|empty` : signature;
      // If we've already requested for this exact key, do not re-dispatch
      if (lastRequestedSignatureRef.current === requestKey) {
        
        return;
      }

      currentQuestionDet.followUpQuestions.forEach((cq) => {
        // Gather the referenced response once
        const prevResp = questionSequenceMap[cq]?.response;

        // Treat 'N/A'/'SKIP', missing or blank as no usable input for follow-up
        const isPrevSkipped = prevResp?.skip === true;
        const isPrevNA = prevResp?.response === 'N/A' || prevResp?.response === 'SKIP';
        const isPrevBlankString = typeof prevResp?.response === 'string' && prevResp.response.trim().length === 0;
        const isPrevMissing = prevResp?.response === undefined || prevResp?.response === null;
        if (isPrevSkipped || isPrevNA || isPrevBlankString || isPrevMissing) {
          SkipQuestion.push(cq);
        }

        // Build context strings only for available responses
        if (language === 'EN') {
          followUpStrings.push(
            `\n\nQuestion:\n${prevResp?.question}\nResponse:\n${prevResp?.response}\n`
          );
        }
        if (language === 'FR') {
          followUpStrings.push(
            `\n\nQuestion:\n${prevResp?.fr}\nResponse:\n${prevResp?.response}\n`
          );
        }
        if (language === 'ES') {
          followUpStrings.push(
            `\n\nQuestion:\n${prevResp?.es}\nResponse:\n${prevResp?.response}\n`
          );
        }

        if (language === 'POR') {
          followUpStrings.push(
            `\n\nQuestion:\n${prevResp?.por}\nResponse:\n${prevResp?.response}\n`
          );
        }
      });
      let _prompt = `Context: ${context}. Here is the sequence of questions and responses so far:`;
      _prompt += followUpStrings.join("");
      const hasCustomPrompt = (currentQuestionDet?.prompt && String(currentQuestionDet.prompt).trim().length > 0);
      const englishOutcome = hasCustomPrompt ? currentQuestionDet.prompt : outcome;
      const frenchOutcome = hasCustomPrompt ? currentQuestionDet.prompt : outcomeFr;
      const spanishOutcome = hasCustomPrompt ? currentQuestionDet.prompt : outcomeEs;
      const portugueseOutcome = hasCustomPrompt ? currentQuestionDet.prompt : outcomePor;

      _prompt += `Task: ${englishOutcome} `;
      if(!hasCustomPrompt){
        _prompt += `Make sure the response is simple enough for a 7th-grader to understand.`;
      }
      _prompt += ` Only return the question itself.`;

      if(language=='FR'){
        _prompt = `Contexte: ${contextFr}. Voici la séquence des questions et des réponses jusqu'à présent:`;
        _prompt += followUpStrings.join("");
        _prompt += `Tâche: Sur la base de ce dialogue, ${frenchOutcome}. `;
        if(!hasCustomPrompt){
          _prompt += `Assurez-vous que votre réponse est assez simple pour qu'un élève de 7e année la comprenne.`;
        }
        _prompt += ` Ne retournez que la question elle-même, uniquement en français.`;
      }

      if(language=='ES'){
        _prompt = `Contexto: ${contextEs}. Aquí está la secuencia de preguntas y respuestas hasta ahora:`;
        _prompt += followUpStrings.join("");
        _prompt += `Tarea: Basado en este diálogo, ${spanishOutcome}. `;
        if(!hasCustomPrompt){
          _prompt += `Asegúrese de que su respuesta sea lo suficientemente simple para que un estudiante de 7º grado la entienda.`;
        }
        _prompt += ` Devuelva la pregunta únicamente en español.`;
      }

      if(language=='POR'){
        _prompt = `Contexto: ${contextPor}. Aqui está a sequência de perguntas e respostas até agora:`;
        _prompt += followUpStrings.join("");
        _prompt += `Tarefa: Com base neste diálogo, ${portugueseOutcome}. `;
        if(!hasCustomPrompt){
          _prompt += `Certifique-se de que sua resposta é suficientemente simples para que um aluno de 7º grau a entenda.`;
        }
        _prompt += ` Retorne apenas a pergunta, somente em português.`;
      }
      // console.log("SkipQuestion", SkipQuestion)

      if (SkipQuestion?.length > 0) {
        // quwstion was skipped because one of the previous questions was skipped
        if (direction === "slide-back") {
          

          handleBack();
        } else {
          const ResponseObj = {
            survey_q_id: currentQuestionDet.id,
            comments: `Auto-skip MultiFollowUp due to missing/blank related comment(s): ${SkipQuestion}`,
            skip: true,
            feedback: "",
            dimension: refQues?.response?.dimension,
            factor: refQues?.response?.factor,
            fr: refQues?.response?.fr,
            es: refQues?.response?.es,
            por: refQues?.response?.por,
            id: refQues?.response?.id,
            q: refQues?.response?.q,
            s: refQues?.response?.s,
            ques_order: refQues?.response?.ques_order,
            question: refQues?.response?.question,
            response: "",
            reverse: refQues?.response?.reverse,
            role: refQues?.response?.role,
            type: refQues?.response?.type,
            prompt: "",
            // Save the prompt text and signature
            prompt_question: _prompt,
            prompt_signature: signature,
          };
          
          saveUpdatedAnswers(
            currentQuestionDet.id,
            ResponseObj,
            currentQuestionDet?.quesType
          );
          setOpen(false);
          handleNext();
        }
      } else {
        // Small deferral to allow upstream state to settle before firing GPT
        // Mark intent immediately so rapid rerenders/StrictMode don't duplicate
        lastRequestedSignatureRef.current = requestKey;
        
        // Re-check before dispatching in case state changed to skip
        const shouldSkipNow = currentQuestionDet.followUpQuestions.some((cq) => {
          const prevResp = questionSequenceMap[cq]?.response;
          const isPrevSkipped = prevResp?.skip === true;
          const isPrevNA = prevResp?.response === 'N/A' || prevResp?.response === 'SKIP';
          const isPrevBlankString = typeof prevResp?.response === 'string' && prevResp.response.trim().length === 0;
          const isPrevMissing = prevResp?.response === undefined || prevResp?.response === null;
          return isPrevSkipped || isPrevNA || isPrevBlankString || isPrevMissing;
        });
        if (shouldSkipNow) {
          // Clear the in-flight marker since we won't dispatch
          lastRequestedSignatureRef.current = null;
          if (direction === "slide-back") {
            
            handleBack();
          } else {
            const ResponseObj = {
              survey_q_id: currentQuestionDet.id,
              comments: `Auto-skip MultiFollowUp due to late-detected blank related comment(s)` ,
              skip: true,
              feedback: "",
              dimension: refQues?.response?.dimension,
              factor: refQues?.response?.factor,
              fr: refQues?.response?.fr,
              es: refQues?.response?.es,
              por: refQues?.response?.por,
              id: refQues?.response?.id,
              q: refQues?.response?.q,
              s: refQues?.response?.s,
              ques_order: refQues?.response?.ques_order,
              question: refQues?.response?.question,
              response: "",
              reverse: refQues?.response?.reverse,
              role: refQues?.response?.role,
              type: refQues?.response?.type,
              prompt: "",
              prompt_question: _prompt,
              prompt_signature: signature,
            };
            
            saveUpdatedAnswers(
              currentQuestionDet.id,
              ResponseObj,
              currentQuestionDet?.quesType
            );
            setOpen(false);
            handleNext();
          }
        } else {
          setLoading(true);
          setPrompt(_prompt);
          dispatch({
            type: SG_GET_CHAT_GPT_SUMMARY,
            payload: {
              token: localToken,
              payload: {
                prompt: `${_prompt}`,
                survey_token: localToken,
                question_no: currentQuestionDet?.sno,
              },
            },
          });
          setFeedbackText("");
        }
      }
    } else {
      // Ensure we have the reference question available even when reusing cached GPT
      if (currentQuestionDet?.followUpQuestions?.length > 0) {
        setRefQues(questionSequenceMap[currentQuestionDet.followUpQuestions[0]]);
      }
      
    }
  }, [
    currentQuestionDet.id,
    questionSequenceMap,
    direction,
    language
  ]);

  // useEffect(() => {
  //   const delayedExecution = () => {
  //     // Your code to run after the delay
  //     let followUpStrings = [];
  //     // if previous qestions were skipped ignore and skip this
  //     // we need to add this because of reset changes !currentQuestionDet?.response
  //     let SkipQuestion = [];
  //     if (
  //       (!currentQuestionDet?.response?.question &&
  //       currentQuestionDet?.followUpQuestions?.length > 0)
  //     ) {
  //       console.log("I am here ======================================= 67", currentQuestionDet?.id )
  //       setRefQues(questionSequenceMap[currentQuestionDet.followUpQuestions[0]]);
  //       currentQuestionDet.followUpQuestions.forEach((cq) => {
  //         // console.log("cq", cq);
  //         // console.log("questionSequenceMap[cq]", questionSequenceMap[cq]?.response);
  //         // console.log("questionSequenceMap[cq]?.response?.skipped", questionSequenceMap[cq]?.response?.skip);
  //         if (questionSequenceMap[cq]?.response?.skip) {
  //           SkipQuestion.push(cq);
  //         }
  //         followUpStrings.push(
  //           `\n\nQuestion:\n${questionSequenceMap[cq]?.response?.question}\nResponse:\n${questionSequenceMap[cq]?.response?.response}\n`
  //         );
  //       });
  
  //       let _prompt = `Context: ${context}. Here is the sequence of questions and responses so far:`;
  //       _prompt += followUpStrings.join("");
  //       _prompt += `Task: Based on this dialogue, ${outcome}. Make sure your response is simple enough for an 7th grader to understand. Only return the question itself.`;
  
  //       console.log("SkipQuestion", SkipQuestion)
  
  //       if (SkipQuestion?.length > 0) {
  //         // quwstion was skipped because one of the previous questions was skipped
  //         if (direction === "slide-back") {
  //           handleBack();
  //         } else {
  //           const ResponseObj = {
  //             survey_q_id: currentQuestionDet.id,
  //             comments: `askOnRefResp - out of range skip checked question ${SkipQuestion}`,
  //             skip: true,
  //             feedback: "",
  //             dimension: refQues?.response?.dimension,
  //             factor: refQues?.response?.factor,
  //             fr: refQues?.response?.fr,
  //             id: refQues?.response?.id,
  //             q: refQues?.response?.q,
  //             ques_order: refQues?.response?.ques_order,
  //             question: refQues?.response?.question,
  //             response: "",
  //             reverse: refQues?.response?.reverse,
  //             role: refQues?.response?.role,
  //             type: refQues?.response?.type,
  //             prompt: "",
  //             prompt_question: "",
  //           };
  //           saveUpdatedAnswers(
  //             currentQuestionDet.id,
  //             ResponseObj,
  //             currentQuestionDet?.quesType
  //           );
  //           setOpen(false);
  //           handleNext();
  //         }
  //       } else {
  //         setPrompt(_prompt);
  //         dispatch({
  //           type: SG_GET_CHAT_GPT_SUMMARY_MULTI,
  //           payload: {
  //             token: localToken,
  //             payload: {
  //               prompt: `${_prompt}`,
  //               survey_token: localToken,
  //               question_no: currentQuestionDet?.sno,
  //             },
  //           },
  //         });
  
  //         setFeedbackText("");
  //       }
  //     }
  
  //     console.log('Delayed execution completed.');
  //   };
  
  //   // Set a delay of, for example, 3000 milliseconds (3 seconds)
  //   const delayMilliseconds = 10;
  
  //   // Use setTimeout to delay the execution of delayedExecution
  //   const timeoutId = setTimeout(delayedExecution, delayMilliseconds);
  
  //   // Cleanup the timeout to avoid memory leaks
  //   return () => clearTimeout(timeoutId);
  
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [questionSequenceMap.id]); // Empty dependency array to run this effect only once after the initial render

  
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = `${
        textareaRef.current.scrollHeight - 16
      }px`;
    }
  }, []);

  const handleInput = (e) => {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight - 16}px`;
  };

  const saveResponse = (value) => {
    const ResponseObj = {
      ques_sort_order: currentQuestionDet.id,
      ques_order: currentQuestionDet?.id,
      id: currentQuestionDet.id,
      followUpQuestions: currentQuestionDet?.followUpQuestions,
      question_type: currentQuestionDet?.quesType,
      question: question,
      fr: refQues?.response?.fr,
      por: refQues?.response?.por,
      es: refQues?.response?.es,
      response: value,
      prompt: prompt,
      clicked: true,
    };
    
    saveUpdatedAnswers(
      currentQuestionDet?.id,
      ResponseObj,
      currentQuestionDet.quesType
    );
  };

  const handleChange = (event) => {
    lastEditAtRef.current = Date.now();
    setFeedbackText(event.target.value);
    saveResponse(event.target.value);
  };

  const { get_chat_gpt } = useSelector(
    (state) => ({
      get_chat_gpt: state.chatgpt,
    }),
    shallowEqual
  );

  useEffect(() => {
    const signature = computeSignature();
    const hasStoredQuestion = !!currentQuestionDet?.response?.question;
    const sameSignature = currentQuestionDet?.response?.prompt_signature === signature;
    const hasStoredResponse = !!currentQuestionDet?.response?.response;

    // If we have a stored question but no stored response for the same signature, keep loader and hide the stale question
    if (hasStoredQuestion && sameSignature && !hasStoredResponse) {
      setLoading(true);
      setQuestion('');
      return;
    }

    // Otherwise, reflect GPT pending/response in UI
    setLoading(get_chat_gpt?.response_pending);
    const gptQuestion = get_chat_gpt.chat_gpt_summary?.response;
    if (gptQuestion) {
      setQuestion(gptQuestion);
      // Persist generated question with the current signature if not saved or signature changed
      if (!hasStoredQuestion || !sameSignature) {
        const ResponseObj = {
          ques_sort_order: currentQuestionDet.id,
          ques_order: currentQuestionDet?.id,
          id: currentQuestionDet.id,
          followUpQuestions: currentQuestionDet?.followUpQuestions,
          question_type: currentQuestionDet?.quesType,
          question: gptQuestion,
          // Persist both the prompt used and the signature used to generate this question
          prompt: prompt,
          prompt_question: prompt,
          prompt_signature: signature,
          // IMPORTANT: Reset any prior response when the question is regenerated for a new signature
          response: "",
          clicked: false,
        };
        saveUpdatedAnswers(
          currentQuestionDet?.id,
          ResponseObj,
          currentQuestionDet.quesType
        );
      }
    }
  }, [get_chat_gpt, currentQuestionDet, language, questionSequenceMap]);

  useEffect(() => {
    if (get_chat_gpt?.response_pending === true) {
      timeout.current = setTimeout(() => {
        setLoading(false)
        SkipQuestion()
      }, 15000);
    }

    if (get_chat_gpt?.response_pending === false) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    setLoading(get_chat_gpt?.response_pending);
    if (get_chat_gpt.chat_gpt_summary?.response) {
      setQuestion(get_chat_gpt.chat_gpt_summary?.response);
    }

    return () => {
      clearTimeout(timeout.current);
    };
  }, [get_chat_gpt]);

  useEffect(() => {
    if (get_chat_gpt?.response_pending === false) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    return () => {
      clearTimeout(timeout.current);
    };
  }, [get_chat_gpt]);

  const handleSkip = () => {
    setOpen(true);
    // Do not clear stored question here; we want to preserve the generated question when returning
    dispatch({
      type: CLEAR_CHAT_GPT_SUMMARY,
    })
    
  };

  function SkipQuestion() {
    const ResponseObj = {
      survey_q_id: currentQuestionDet.id,
      feedback: "",
      dimension: refQues?.response?.dimension,
      factor: refQues?.response?.factor,
      fr: refQues?.response?.fr,
      es: refQues?.response?.es,
      por: refQues?.response?.por,
      id: refQues?.response?.id,
      q: refQues?.response?.q,
      ques_order: refQues?.response?.ques_order,
      // Persist the GPT-generated follow-up question so it remains consistent when navigating back
      question: question,
      response: "",
      reverse: refQues?.response?.reverse,
      role: refQues?.response?.role,
      type: refQues?.response?.type,
      prompt: "",
      // Store prompt (if we had one) and signature so a revisit with unchanged inputs does not re-trigger GPT
      prompt_question: (prompt || ''),
      prompt_signature: computeSignature(),
    };
    
    saveUpdatedAnswers(
      currentQuestionDet.id,
      ResponseObj,
      currentQuestionDet?.quesType
    );
    setOpen(false);
    // Clear pending GPT fetch state only; the saved response carries the question
    dispatch({
      type: CLEAR_CHAT_GPT_SUMMARY,
    })
    handleNext("forced");
  }

  return (
    <FeedbackContainer>

      <Title>
        <Circle>
          <IMG src={Logo} />
        </Circle>
       {words['Follow Up'][language]}
      </Title>
      <QuestionContainer>
        {loading ? (
          <Loader active inline />
        ) : (
          <FadeInText>{question}</FadeInText>
        )}
      </QuestionContainer>
{/* 
      <Title>
        <Circle>
          <IMG src={Logo} />
        </Circle>
        Innerlogic AI
      </Title>
      <Description>
        {loading ? (
          <Loader active inline />
        ) : (
          <Typewriter
            onInit={(typewriter) => {
              typewriter
                .changeDelay(14)
                .typeString(question)
                .pauseFor(100)
                .start();
            }}
          />
        )}
      </Description> */}

      <StyledTextarea
        id={`txt_${currentQuestionDet?.id}`}
        value={feedbackText}
        onChange={handleChange}
        placeholder={words["textarea"][language]}
        ref={textareaRef}
        onInput={handleInput}
      />
      <Skip onClick={handleSkip}>{words['Skip'][language]} &gt;</Skip>
      <SkipModal open={open} setOpen={setOpen} SkipQuestion={SkipQuestion} language={language}/>
    </FeedbackContainer>
  );
};

export default MultiFollowUp;

// {/* <FeedbackContainer>
// <Title><Circle><IMG src={Logo}/></Circle>Innerlogic AI</Title>
// <Description>
//    {loading? <Loader active inline /> :
//        <Typewriter
//        onInit={(typewriter) => {
//        typewriter.changeDelay(14)
//        .typeString(question)
//        .pauseFor(100)
//        .start()

//        }}
//    />}
// </Description>

// <StyledTextarea
//    id={`txt_${currentQuestionDet?.id}`}
//    value={feedbackText}
//    onChange={handleChange}
//    placeholder="Type your answer here"
//    ref={textareaRef}
//    onInput={handleInput}/>

// <Skip onClick={handleSkip}>Skip &gt;</Skip>
// <SkipModal open={open} setOpen={setOpen} SkipQuestion={SkipQuestion} />
// </FeedbackContainer> */}

const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 600px;
  width: 100%;
  font-family: "Raleway", sans-serif;
`;


const QuestionContainer = styled.div`
  margin-bottom: 34px;
  width: 100%;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const FadeInText = styled.div`
  color: #2a3039;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  animation: ${fadeIn} 1s ease-in;
`;

const Description = styled.div`
  color: #2a3039;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 34px;
  line-height: 1.6;
`;
const Title = styled.div`
  color: #2d70e2;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 40px;
`;

const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #2a3039;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  resize: none;
  font-family: "Raleway", sans-serif;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #2d70e2;
    outline: 0;
  }
`;

const Circle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: #2d70e2;
  margin-right: 10px;
  min-width: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;

const IMG = styled.img`
  width: 20px;
`;

const Skip = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #2d70e2;
  margin-top: 40px;
  cursor: pointer;
`;
